import { PaperAirplaneIcon } from "@heroicons/react/24/solid";
import { useMeeting, usePubSub } from "@videosdk.live/react-sdk";
import React, { useEffect, useRef, useState } from "react";
import { formatAMPM, json_verify, nameTructed } from "../../../utils/helper";

const ChatMessage = ({ senderId, senderName, text, timestamp, isBot }) => {
  const mMeeting = useMeeting();
  const localParticipantId = mMeeting?.localParticipant?.id;
  const localSender = localParticipantId === senderId && !isBot;

  const panelDetails = JSON.parse(
    sessionStorage.getItem("panelDetails") || "{}",
  );
  const isPanelMode = panelDetails?.panel && panelDetails.panel !== "PNLO";

  //  For PNLO, use name from sessionStorage
  const getPNLOBotName = () => {
    if (panelDetails?.pnlf1) return panelDetails.pnlf1;
    if (panelDetails?.pnlf2) return panelDetails.pnlf2;
    if (panelDetails?.pnlm1) return panelDetails.pnlm1;
    if (panelDetails?.pnlm2) return panelDetails.pnlm2;
    if (panelDetails?.botName) return panelDetails.botName;
    return "Interviewer";
  };

  const resolvedBotName =
    isBot && isPanelMode
      ? nameTructed(senderName || senderId || "Panel", 15)
      : isBot
        ? nameTructed(getPNLOBotName(), 15)
        : localSender
          ? "You"
          : nameTructed(senderName, 15);

  return (
    <div
      className={`flex ${localSender ? "justify-end" : "justify-start"} mt-4`}
      style={{
        maxWidth: "100%",
      }}
    >
      <div
        className={`flex ${
          localSender ? "items-end" : "items-start"
        } flex-col py-2 px-3 updated-chat-bg rounded-lg max-w-[80%] ${
          isBot
            ? "bg-white"
            : //  "bg-gradient-to-r from-blue-600 to-blue-700 border-l-4 border-blue-400"
              localSender
              ? "bg-gray-600"
              : "bg-gray-700"
        }`}
      >
        <div className="flex items-center gap-2 mb-1">
          {isBot && (
            <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
          )}
          <p
            className="text-tertiaryFontSize font-medium font-capitalize"
            style={{ color: "#fff" }}
          >
            {resolvedBotName}
          </p>
        </div>
        <div>
          <p
            className={`inline-block whitespace-pre-wrap text-white break-words text-left ${
              isBot ? "text-fontColor font-medium" : "text-white"
            }`}
          >
            {text}
          </p>
        </div>
        <div className="mt-2 self-end">
          <p
            className="text-tertiaryFontSize italic"
            style={{ color: isBot ? "#c9c9c9" : "#c9c9c9" }}
          >
            {formatAMPM(new Date(timestamp))}
          </p>
        </div>
      </div>
    </div>
  );
};

const ChatInput = ({ inputHeight }) => {
  const [message, setMessage] = useState("");
  const { publish } = usePubSub("CHAT");
  const input = useRef();

  return (
    <div
      className="w-full flex items-center px-2 "
      style={{ height: inputHeight }}
    >
      {/* <div className="relative w-full  ">
        <span className="absolute inset-y-0 right-0 flex mr-2 rotate-90 ">
          <button
            disabled={message.length < 2}
            type="submit"
            className="p-1 focus:outline-none focus:shadow-outline "
            onClick={() => {
              const messageText = message.trim();
              if (messageText.length > 0) {
                publish(messageText, { persist: true });
                setTimeout(() => {
                  setMessage("");
                }, 100);
                input.current?.focus();
              }
            }}
          >
            <PaperAirplaneIcon
              className={`w-6 h-6 -rotate-90 ${
                message.length < 2 ? "text-gray-500 " : "text-white"
              }`}
            />
          </button>
        </span>
        <input
          type="text"
          className="py-2 text-secondaryFontSize text-white border-gray-400 border bg-black  pr-10 pl-3 focus:outline-none w-full rounded-3xl"
          placeholder="Write your message"
          autoComplete="off"
          ref={input}
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          onKeyPress={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              const messageText = message.trim();

              if (messageText.length > 0) {
                publish(messageText, { persist: true });
                setTimeout(() => {
                  setMessage("");
                }, 100);
                input.current?.focus();
              }
            }
          }}
        />
      </div> */}
    </div>
  );
};

const ChatMessages = ({ listHeight }) => {
  const listRef = useRef();
  const { messages } = usePubSub("CHAT");

  const scrollToBottom = (data) => {
    if (!data) {
      if (listRef.current) {
        listRef.current.scrollTop = listRef.current.scrollHeight;
      }
    } else {
      const { text } = data;

      if (json_verify(text)) {
        const { type } = JSON.parse(text);
        if (type === "CHAT") {
          if (listRef.current) {
            listRef.current.scrollTop = listRef.current.scrollHeight;
          }
        }
      }
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const processMessage = (msg) => {
    let messageData = {
      senderId: msg.senderId,
      senderName: msg.senderName,
      text: msg.message,
      timestamp: msg.timestamp,
      isBot: false,
    };

    // Check if the message is a JSON string from the bot
    try {
      const parsedMessage = JSON.parse(msg.message);
      if (parsedMessage.isBot) {
        messageData = {
          senderId: parsedMessage.senderId,
          senderName: parsedMessage.senderName,
          text: parsedMessage.message,
          timestamp: parsedMessage.timestamp,
          isBot: true,
        };
      }
    } catch (e) {
      // If parsing fails, treat as regular message
      // Check if message starts with bot prefix (fallback for old format)
      // if (msg.message.startsWith("ANUSHKA_BOT: ")) {
      //   messageData = {
      //     senderId: "anushka-bot",
      //     senderName: "Anushka",
      //     text: msg.message.replace("ANUSHKA_BOT: ", ""),
      //     timestamp: msg.timestamp,
      //     isBot: true,
      //   };
      // }
    }

    return messageData;
  };

  return messages ? (
    <div
      ref={listRef}
      style={{
        overflowY: "scroll",
        height: listHeight,
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
      }}
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div className="p-4">
        {messages
          .map((msg, i) => {
            const processedMsg = processMessage(msg);
            return { ...processedMsg, originalIndex: i };
          })
          .filter(
            (processedMsg) =>
              !["EOF", "LST"].includes(processedMsg.text.trim()),
          )
          .map((processedMsg) => (
            <ChatMessage
              key={`chat_item_${processedMsg.originalIndex}`}
              senderId={processedMsg.senderId}
              senderName={processedMsg.senderName}
              text={processedMsg.text}
              timestamp={processedMsg.timestamp}
              isBot={true}
            />
          ))}
      </div>
    </div>
  ) : (
    <p>No messages</p>
  );
};

export function ChatPanel({ panelHeight }) {
  const inputHeight = 42;
  const listHeight = panelHeight - inputHeight;

  return (
    <div className="custom-scrollbar">
      <ChatMessages listHeight={listHeight} />
      <ChatInput inputHeight={inputHeight} />
    </div>
  );
}
